import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05b6ced3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "headline" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "88",
  height: "3",
  viewBox: "0 0 88 3"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    id: "Line",
    x2: "85",
    fill: "none",
    stroke: "#fff",
    "stroke-linecap": "round",
    "stroke-width": "3"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "88",
  height: "3",
  viewBox: "0 0 88 3"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    id: "Line",
    x2: "85",
    fill: "none",
    stroke: "#fff",
    "stroke-linecap": "round",
    "stroke-width": "3"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", null, _toDisplayString(_ctx.title), 1),
    _hoisted_3
  ]))
}